var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 29,
    viewBox: "0 0 107 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    clipPath: "url(#clip0_1132_12279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE5\xBD\xA2\xE7\x8A\xB6\xE7\xBB\x93\xE5\x90\x88",
    d: "M6.69244 26.6302C3.20649 24.6293 0.862126 21.2903 0.0560676 17.6564C-0.280026 16.195 0.940497 14.721 2.49711 14.7084L12.2575 14.6932C13.1778 14.6779 13.998 15.1487 14.4448 15.9487L19.3117 24.3599C20.1474 25.7457 19.4054 27.4943 17.8565 27.9643C14.1908 28.9409 10.1784 28.6311 6.69244 26.6302ZM25.229 14.3601L15.4686 14.3753C14.5483 14.3906 13.7281 13.9198 13.2813 13.1198L8.41438 4.70857C7.64703 3.36205 8.28127 1.64215 9.76179 1.13287C13.3303 0.00992796 17.411 0.358907 20.897 2.35983C24.3829 4.36075 26.7273 7.69974 27.5333 11.3336C28.035 12.9807 26.854 14.3867 25.229 14.3601Z",
    fill: "#007AF0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ABEx"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE5\xBD\xA2\xE7\x8A\xB6\xE7\xBB\x93\xE5\x90\x88_2",
    d: "M34.6497 23.6875H38.7179L41.5525 18.8575H49.0066L49.8465 23.6875H53.6785L50.1877 5.3125H45.8833L34.6497 23.6875ZM43.3373 15.8125L47.3268 9.04L48.4817 15.8125H43.3373ZM59.1378 5.3125L55.2271 23.6875H64.6496C68.6391 23.6875 71.6575 21.1938 71.6575 17.8338C71.6575 16.3638 70.8701 15.13 69.5578 14.3687C71.3426 13.3975 72.5237 11.665 72.5237 9.69625C72.5237 7.045 70.3714 5.3125 67.0381 5.3125H59.1378ZM66.4344 8.4625C67.8517 8.4625 68.7179 9.17125 68.7179 10.3263C68.7179 11.77 67.4843 12.82 65.8045 12.82H61.2638L62.1825 8.4625H66.4344ZM64.7284 20.5375H59.6365L60.6339 15.7862H65.3846C66.9594 15.7862 67.9042 16.5475 67.9042 17.8075C67.9042 19.4087 66.5919 20.5375 64.7284 20.5375ZM74.4922 23.6875H88.7179V20.38H78.2979V16.0225H85.0958V12.82H78.2979V8.62H88.6129V5.3125H74.4922V23.6875ZM89.7153 23.6875H93.731L96.9593 19.33L100.188 23.6875H104.387L99.0328 16.6787L104.072 10.0113H100.03L97.0381 14.08L94.0197 10.0113H89.8465L94.9646 16.7312L89.7153 23.6875Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1132_12279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106.138,
    height: 28,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHeader);
export default __webpack_public_path__ + "static/media/logo-header.c025f9e656dfe779aff0245587d43e6d.svg";
export { ForwardRef as ReactComponent };